import React, { useEffect, useRef, useState } from "react";
import EvaluatorLayout from "../../../components/evaluator-layout";
import styled from "styled-components";
import ImageFireWork from '../../../assets/images/image-firework.svg'
import GenderComponent from "../../../components/evaluation-form-components/gender";
import InputComponent from "../../../components/evaluation-form-components/input";
import IconCamera from '../../../assets/images/icon-camera.svg'
import IconPersonYellow from '../../../assets/images/icon-person-yellow.svg'
import DatePickerComponent from "../../../components/evaluation-form-components/date_picker";
import ButtonComponent from "../../../components/button";
import LoadingModal from "../../../components/loading-modal";
import { useSearchParams } from "react-router-dom";
import CoreAPI from "../../../services/core";
import { onSleep, onLoginLineLiff } from "../../../utils/default";
import IconIGStep from "../../../assets/images/icon-ig-step.svg"

const Container = styled.div`
    width: 100%;
`;

const Banner = styled.div`
    width: 100%;
    height: 122px;
    position: relative;

    .bg-cover {
        width: 100%;
        height: 50%;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(153.06deg, rgba(246, 210, 133, 0.3) -0.31%, rgba(187, 240, 243, 0.3) 99.69%);
    }

    .image-firework-box {
        position: absolute;
        z-index: 1;
    }

    .image-profile-box {
        width: 80px;
        height: 80px;
        position: absolute;
        z-index: 1;
        border-radius: 50%;
        background-color: #25368D;

        .image-profile {
            width: 50%;
            object-fit: contain;
        }
    }
`;

const Body = styled.div`
    width: calc(100% - 48px);
    height: calc(100% - 160px);
    padding: 24px;
    display: flex;
    flex-direction: column;

    .description {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: left;
        margin-bottom: 8px;
    }
    .title {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: left;
        margin-bottom: 12px;
    }
`;

const PoweredBox = styled.div`
    width: 100%;
    height: 24px;
    color: #505050;
    font-size: 12px;
    font-weight: 300;
    line-height: 20.93px;
    margin-top: auto;
    margin-bottom: 0px;
    padding-top: 24px;

    .image {
        margin-left: 16px;
    }
`;

function EvaluatorEvaluatorProfilePage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const searchParamsRef = useRef({
        evaluator_id: null,
        line_user_id: null,
    })
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isInvalidValue, setIsInvalidValue] = useState({
        mobile_number: false
    });
    const [detail, setDetail] = useState({
        gender: null,
        mobile_number: null,
        birthdate: null,
        province: null,
    })

    useEffect(() => {
        //evaluator_id=f7b4aa5e-7c36-4c8c-9b3d-080577d21279&line_user_id=U59604d0e5021d542ab0ccdd228b2a67d
        onInit();
    }, [])

    async function onInit() {
        setIsLoading(true);
        try {
            const liffResponse = await onLoginLineLiff(window.location.href);
            console.log("liffResponse", liffResponse);

            let evaluator = null;
            // 1. Prioritize LIFF User
            if (liffResponse?.profile?.userId) {
                evaluator = await onGetEvaluatorByLineUserId(liffResponse.profile.userId);
                if (evaluator?.evaluator_id) {
                    const newParams = new URLSearchParams(searchParams);
                    newParams.set("evaluator_id", evaluator.evaluator_id);
                    newParams.set("line_user_id", liffResponse.profile.userId);
                    setSearchParams(newParams);

                    // Update ref for consistency in this render cycle if needed elsewhere
                    searchParamsRef.current.evaluator_id = evaluator.evaluator_id;
                    searchParamsRef.current.line_user_id = liffResponse.profile.userId;
                }
            }
            // 2. Fallback to URL Params (only if no LIFF user found / not logged in)
            if (!evaluator) {
                searchParamsRef.current.evaluator_id = searchParams.get("evaluator_id");
                searchParamsRef.current.line_user_id = searchParams.get("line_user_id");

                if (searchParamsRef.current.evaluator_id) {
                    evaluator = await onGetEvaluatorById(searchParamsRef.current.evaluator_id);
                } else if (searchParamsRef.current.line_user_id) {
                    evaluator = await onGetEvaluatorByLineUserId(searchParamsRef.current.line_user_id);
                }
            }
        } catch (error) {
            console.error("Error onInit:", error);
        } finally {
            await onSleep(500);
            setIsLoading(false);
        }
    }

    async function onGetEvaluatorById(param) {
        let response = null;
        let _detail;
        try {
            response = await CoreAPI.satHttpService.getEvaluatorById(param);
        } catch { }
        if (response) {
            _detail = {
                ...response,
                birthdate: response.birthdate ? new Date(response.birthdate) : null
            }
        }
        if (_detail) {
            setDetail(_detail)
        }
        return _detail;
    }

    async function onGetEvaluatorByLineUserId(id) {
        let response = null;
        let _detail;
        try {
            let body = {
                line_user_id: id,
            }
            response = await CoreAPI.satHttpService.upsertEvaluatorByLineUserIdDto(body);
        } catch { }
        if (response) {
            _detail = {
                ...response,
                birthdate: response.birthdate ? new Date(response.birthdate) : null
            }
        }
        if (_detail) {
            setDetail(_detail)
        }
        return _detail;
    }
    async function onUpdateEvaluator(param) {
        let response = null;
        try {
            let body = {
                evaluator_id: searchParamsRef.current.evaluator_id,
                ...param,
            }
            response = await CoreAPI.satHttpService.updateEvaluatorProfile(body);
        } catch { }
        return response;
    }
    function onCheckFormat(key, value) {
        let check = true;
        if (!value) return check;
        let regex;
        if (key === "mobile_number") {
            regex = /^(0[689]{1})+([0-9]{8})+$/;
            const test = regex.test(value)
            check = test;
        }
        return check;
    }

    function handleClickEdit() {
        setIsEdit(true);
    }
    async function handleClickSave() {
        if (!onCheckFormat("mobile_number", detail.mobile_number)) {
            setIsInvalidValue((prev) => { return { ...prev, mobile_number: true } })
            return;
        }
        if (!detail?.evaluator_id) {
            setIsEdit(false);
            return;
        }
        setIsLoading(true);
        await onUpdateEvaluator(detail);
        await onSleep(500);
        setIsLoading(false);
        setIsEdit(false);
    }
    function handleChange(key, value) {
        let _detail = {
            ...detail
        }
        _detail[key] = value || null;
        setDetail(_detail);
        let _isInvalidValue = { ...isInvalidValue };
        for (let item of Object.keys(_isInvalidValue)) {
            _isInvalidValue[item] = false;
        }
        setIsInvalidValue(_isInvalidValue);
    }

    return (
        <EvaluatorLayout showBack={false}>
            <Container>
                <Banner className="content-center">
                    <div className="bg-cover"></div>
                    <div className="image-firework-box"><img alt="img" className="image-firework" src={ImageFireWork} /></div>
                    <div className="image-profile-box content-center"><img alt="img" className="image-profile" src={IconPersonYellow} /></div>
                </Banner>
                <Body>

                    <div className="description">ข้อมูลส่วนตัว</div>
                    <GenderComponent
                        disable={!isEdit}
                        value={detail.gender}
                        onSelect={(e) => handleChange("gender", e)}
                    />
                    <InputComponent
                        disable={!isEdit}
                        label={"ชื่อ"}
                        placeholder={"กรุณาระบุชื่อ"}
                        value={detail.firstname}
                        onInput={(e) => handleChange("firstname", e)}
                    />
                    <InputComponent
                        disable={!isEdit}
                        label={"นามสกุล"}
                        placeholder={"กรุณาระบุนามสกุล"}
                        value={detail.lastname}
                        onInput={(e) => handleChange("lastname", e)}
                    />
                    <InputComponent
                        disable={!isEdit}
                        label={"ข้อมูลการติดต่อ"}
                        placeholder={"กรุณาระบุหมายเลขโทรศัพท์"}
                        value={detail.mobile_number}
                        onInput={(e) => handleChange("mobile_number", e)}
                        isError={isInvalidValue.mobile_number}
                        labelError={"เบอร์โทรศัพไม่ถูกต้อง"}
                    />
                    <DatePickerComponent
                        disable={!isEdit}
                        label={"วัน เดือน ปี เกิด"}
                        placeholder={"กรุณาเลือกวันเดือนปีเกิด"}
                        value={detail.birthdate}
                        onSelect={(e) => handleChange("birthdate", e)}
                    />
                    <InputComponent
                        disable={!isEdit}
                        label={"ภูมิลำเนา"}
                        placeholder={"กรุณาระบุ"}
                        value={detail.province}
                        onInput={(e) => handleChange("province", e)}
                    />

                    {!isEdit ?
                        <ButtonComponent
                            label={"แก้ไขข้อมูล"}
                            variant={"secondary"}
                            style={{ marginTop: "48px" }}
                            onClick={handleClickEdit}
                        />
                        :
                        <ButtonComponent
                            label={"บันทึกข้อมูล"}
                            variant={"primary"}
                            style={{ marginTop: "48px" }}
                            onClick={handleClickSave}
                        />
                    }

                    <PoweredBox className="content-center">Powered by <img alt="img" className="image" src={IconIGStep} /></PoweredBox>
                </Body>
            </Container>
            <LoadingModal open={isLoading} />
        </EvaluatorLayout>
    )
}

export default EvaluatorEvaluatorProfilePage;